import { useTranslation } from "react-i18next";
import {
  useCreateCollaborativeGroupWork,
  useGetCollaborativeGroupWork,
  getCollaborativeGroupWork,
} from "@packages/api/madlenAPI";
import {
  CollaborativeGroupWorkResponseDto,
  CollaborativeGroupWorkCreateRequestDto,
} from "@packages/api/madlenAPI.schemas";
import { CreateModalProps } from "../../../components/create-modal";
import CollaborativeCard from "../../../components/collaborative/CollaborativeCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import { CollaborativeLearningCreateModal } from "@features/tools/components/create-modal/modals";

const CreateCollaborativeView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CollaborativeLearningCreateModal
      title={t("collaborative.form.generateButton")}
      backPath="/content/collaborative"
      loadingTitle={t("collaborative.result.loading.title")}
      errorTitle={t("collaborative.result.error.title")}
      errorDescription={t("collaborative.result.error.loadingError")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    onCreateAgain,
  }: {
    toolData: CollaborativeGroupWorkResponseDto;
    onCreateAgain: () => void;
  }) => (
    <CollaborativeCard collaborative={toolData} onCreateAgain={onCreateAgain} />
  );

  return (
    <GenericToolCreationPage
      toolType="collaborative"
      useCreateTool={useCreateCollaborativeGroupWork}
      useGetTool={useGetCollaborativeGroupWork}
      getTool={getCollaborativeGroupWork}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: CollaborativeGroupWorkResponseDto) =>
        data?.peerEvaluationQuestions
      }
    />
  );
};

export default CreateCollaborativeView;
